import { articles } from '@/mocks/site';
import { Link } from 'react-router-dom';

export default function LatestContent() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              最新内容
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              每日更新，精彩不停
            </p>
          </div>
          <Link
            to="/article/1"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            更多文章
            <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-white rounded-lg overflow-hidden hover:bg-background-50 transition-colors"
            >
              <div className="aspect-video overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                  {article.categoryName}
                </span>
                <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2">
                  {article.summary}
                </p>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}